export function run() {
  const containers = document.querySelectorAll("[data-controller=RequireInputs]")

  containers.forEach((container) => runInstance(container))
}

function runInstance(container) {
  const inputTargets = container.querySelectorAll("[data-target=required-input]")
  const managedInput = container.querySelector("[data-target=require-inputs-managed-input]")

  function handleChange() {
    const allHaveValues = Array.from(inputTargets).every((t) => t.value.trim().length > 0)
    managedInput.disabled = !allHaveValues
  }

  inputTargets.forEach((input) => {
    input.addEventListener("input", handleChange)
  })

  handleChange()
}
